import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';

const CircularMenu = ({ handleLogout, theme, userId }) => {
  const [isOpen, setIsOpen]   = useState(false);
  const menuRef               = useRef(null);
  const isDark                = theme === 'dark';
  const navigate              = useNavigate();
  const { slug }               = useParams();
  const basePath                = slug ? `/creador/${slug}` : '/dashboard';

  const toggleMenu = () => setIsOpen(p => !p);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const goToProfile = () => {
    setIsOpen(false);
    navigate(`${basePath}/users/${userId}`);
  };

  return (
    <Wrapper ref={menuRef}>
      <TriggerBtn onClick={toggleMenu} isDark={isDark}>
        ⋮
      </TriggerBtn>

      {isOpen && (
        <Dropdown isDark={isDark}>

          {/* Perfil */}
          <Item onClick={goToProfile} isDark={isDark}>
            <ItemIcon>👤</ItemIcon>
            <ItemText isDark={isDark}>Mi Perfil</ItemText>
          </Item>

          {/* Ajustes — deshabilitado por ahora */}
          <Item isDark={isDark} disabled>
            <ItemIcon style={{ opacity: 0.35 }}>⚙️</ItemIcon>
            <ItemText isDark={isDark} style={{ opacity: 0.35 }}>Ajustes</ItemText>
            <ComingSoon isDark={isDark}>Próximamente</ComingSoon>
          </Item>

          <Divider isDark={isDark} />

          {/* Cerrar sesión */}
          <Item
            isDark={isDark}
            danger
            onClick={() => { handleLogout(); setIsOpen(false); }}
          >
            <ItemIcon>🚪</ItemIcon>
            <ItemText isDark={isDark}>Cerrar Sesión</ItemText>
          </Item>

        </Dropdown>
      )}
    </Wrapper>
  );
};

/* ── Styled Components ── */

const Wrapper = styled.div`
  position: relative;
`;

const TriggerBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: var(--text-main);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: ${p => p.isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'};
    transform: rotate(90deg);
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 48px;
  right: 0;
  min-width: 190px;
  background: ${p => p.isDark ? '#1e1e1e' : '#ffffff'};
  border: 1px solid ${p => p.isDark ? '#2a2a2a' : '#e8e8e8'};
  border-radius: 12px;
  padding: 6px;
  z-index: 1100;
  box-shadow: 0 8px 24px ${p => p.isDark ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.12)'};
  animation: fadeIn 0.15s ease;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

const Item = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: ${p => p.disabled ? 'default' : 'pointer'};
  text-align: left;
  transition: background 0.15s ease;
  pointer-events: ${p => p.disabled ? 'none' : 'auto'};

  &:hover {
    background: ${p =>
      p.danger
        ? 'rgba(220,53,69,0.1)'
        : p.isDark
          ? 'rgba(255,255,255,0.06)'
          : 'rgba(0,0,0,0.04)'
    };
  }
`;

const ItemIcon = styled.span`font-size: 16px; flex-shrink: 0;`;

const ItemText = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${p => p.isDark ? '#e0e0e0' : '#222'};
  flex: 1;
`;

const ComingSoon = styled.span`
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 20px;
  background: ${p => p.isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'};
  color: ${p => p.isDark ? '#555' : '#bbb'};
`;

const Divider = styled.div`
  height: 1px;
  background: ${p => p.isDark ? '#2a2a2a' : '#f0f0f0'};
  margin: 4px 0;
`;

export default CircularMenu;